{
  "seo": {
    "title": "School Integrations",
    "description": "Manage Google Classroom and other integrations."
  },
  "title": "Integrations",
  "subtitle": "Connect your school tools to sync rosters and assignments.",
  "actions": {
    "connect": "Connect Google Classroom",
    "sync": "Sync now",
    "disconnect": "Disconnect"
  },
  "connections": {
    "title": "Active connections",
    "loading": "Loading connections...",
    "empty": "No integrations connected yet.",
    "statusLabel": "Status: {status}",
    "lastSync": "Last sync: {date}"
  },
  "errors": {
    "connect": "Unable to start OAuth flow."
  }
}
